(function () {
  // Only run on collection pages
  if (!/\/collections\/[^/]+/.test(window.location.pathname)) return;

  // Map collection handle -> Hue product id
  var PRODUCT_ID_BY_HANDLE = {
    "moisturizers-new": "hppy-collection-moisturizers",
    "fridge-fresh-cryo-facial-masks": "hppy-collection-cryo",
    "bundles-sets-new": "hppy-collection-bundles",
    "cleansers-new": "hppy-collection-cleansers",
    "serums-new": "hppy-collection-serums"
  };

  // Target: section wrapper id contains __multi_column_8yFqcm
  var TARGET_SELECTOR = '[id*="__rich_text"]';

  function getCollectionHandle() {
    var parts = window.location.pathname.split("/").filter(Boolean);
    var idx = parts.indexOf("collections");
    return idx >= 0 && parts[idx + 1] ? parts[idx + 1] : null;
  }

  function getHueProductId() {
    var handle = getCollectionHandle();
    return handle ? PRODUCT_ID_BY_HANDLE[handle] : null;
  }

  function createHueSection(hueProductId) {
    var section = document.createElement("section");
    section.className = "container section-spacing";
    section.setAttribute("data-hue-mini-review-collection", "");

    var mount = document.createElement("div");
    mount.id = "hue-mini-review-module";
    mount.className = "hue-module";
    mount.setAttribute("data-product-id", hueProductId);

    section.appendChild(mount);
    return section;
  }

  function insertOnce() {
    if (document.querySelector("[data-hue-mini-review-collection]")) return true;

    var hueProductId = getHueProductId();
    if (!hueProductId) return true; // nothing to do for this collection

    var targetSection = document.querySelector(TARGET_SELECTOR);
    if (!targetSection) return false;

    var hueSection = createHueSection(hueProductId);

    targetSection.parentNode.insertBefore(hueSection, targetSection);

    document.dispatchEvent(new CustomEvent("hue-mini-collection-mounted", { bubbles: true }));
    return true;
  }

  function boot() {
    if (insertOnce()) return;

    var obs = new MutationObserver(function () {
      if (insertOnce()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(function () {
      try { obs.disconnect(); } catch (e) {}
    }, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
